import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import PremiumBadgeIcon from 'components/Icons/PremiumBadgeIcon';

import styles from './EmptyReelsCTA.module.scss';

interface EmptyReelsCTAProps {
  upgradeUrl: string;
}

const EmptyReelsCTA = ({ upgradeUrl }: EmptyReelsCTAProps) => {
  return (
    <div className={styles.emptyReelsCTA}>
      <div className={styles.emptyReelsCTAContent}>
        <PremiumBadgeIcon className={styles.premiumBadgeIcon} height="46px" width="36px" />
        <Typography variant="title2" color="white">
          No clips available
        </Typography>
        <Typography variant="body1" color="white">
          Start your free trial to view the Live cam stream now or check back later for highlights.
        </Typography>
        <Button
          className={styles.emptyReelsCTAButton}
          disableFocusRipple
          disableRipple
          disableTouchRipple
          href={upgradeUrl}
          size="medium"
          variant="primary"
        >
          Start free trial
        </Button>
      </div>
    </div>
  );
};

export default EmptyReelsCTA;
